var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2,23c-2.6,0-5.3,0-8,0c0.1-0.5,0.5-0.8,1-0.8c0.2,0,0.5,0,0.8,0c0-0.1,0-0.2,0-0.3c0-0.6,0-1.2,0-1.8 c0-1.2,0.7-2.1,1.9-2.5c0.2-0.1,0.5-0.1,0.8-0.1c0-0.4,0-0.8,0-1.3c-1.6,0-2.7,0.7-3.5,2.1c-0.4,0.7-0.5,1.5-0.4,2.3 c0,0.2,0,0.3-0.2,0.4C9.6,21.3,9,22.2,9,23c-1.3,0-2.5,0-3.8,0c-0.1-1,0.5-2.1,1.6-2.4C7,20.5,7,20.4,7,20.3c0-1.4,0-2.7,0-4.1 c0-0.1,0-0.2,0-0.3c-0.3-0.8-0.5-1.7-0.8-2.5c-0.3-0.8-0.4-1.6-0.4-2.3c0-0.3,0-0.5,0-0.8c-0.5,0-1,0-1.5,0c-1,0-1.9-0.7-2-1.7 c-0.1-0.4,0-0.8-0.1-1.3c0-0.1,0-0.2,0.1-0.3c0.5-0.3,1-0.6,1.5-1c0.1,0,0.1-0.1,0.1-0.2C4,5,4.4,4.4,5,3.9c0,0,0.1-0.1,0.1-0.2 c0-0.6,0-1.2,0-1.9c0-0.5,0-0.5,0.4-0.7c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0c0.2,0.1,0.4,0.2,0.5,0.4C7,1.9,7.5,2.5,8.1,3 c0,0,0.1,0.1,0.2,0.1c1.7,0.3,2.7,1.4,3.2,3c0.2,0.5,0.2,1.1,0.1,1.7c0,0.4,0.1,0.7,0.4,1c1.1,1.2,2.2,2.4,3.3,3.6 c1.7,2,2.6,4.2,2.8,6.8C18.3,20.6,18.2,21.8,18.2,23z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.5,22.9c0-1,0-2,0-3c0,0,0-0.1,0.1-0.1c0.7-0.3,1-0.9,1-1.7c0-0.3,0-0.7,0-1c0.4,0,0.8,0,1.3,0c0,0,0,0.1,0,0.1 c0,1,0,2,0,3.1c0,1.2-1,2.4-2.2,2.7C19.6,22.9,19.5,22.9,19.5,22.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimal);
export default __webpack_public_path__ + "static/media/animal.21ae4de5bd13b25580f6c60001a2c130.svg";
export { ForwardRef as ReactComponent };